// extracted by mini-css-extract-plugin
export default {"error":"LanguagesDropdown_error__QisE8","wrapper":"LanguagesDropdown_wrapper__ziIkd","updatedWrapper":"LanguagesDropdown_updatedWrapper__uZOik"};